/**
 * RTE-X16B2 — execution topology lock model for Route Editor.
 * lockState is hydrated from RouteExecutionProjection; legacy actualAt/status are not used.
 */

import type { StopExecutionLockState } from './deliveryGroupTypes';

export type StopExecutionState = StopExecutionLockState;

export type StopExecutionLockInput = {
  id?: number | null;
  uid?: string | null;
  position?: number | null;
  /** Authoritative when set — from routeExecutionProjection.stopProgress via hydration. */
  lockState?: StopExecutionLockState | null;
  executionState?: string | null;
  isCompleted?: boolean | null;
};

export type ExecutionLockRouteContext = {
  routeStatus?: string | null;
  inTransit?: boolean;
  activeExecutionStopId?: number | null;
  activeExecutionStopUid?: string | null;
};

export function isRouteInTransitExecution(ctx: ExecutionLockRouteContext): boolean {
  if (ctx.inTransit === true) return true;
  const normalized = String(ctx.routeStatus ?? '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '_');
  return normalized === 'IN_TRANSIT';
}

export function classifyStopExecutionState(
  stop: StopExecutionLockInput,
  _ctx?: ExecutionLockRouteContext,
  _allStops?: StopExecutionLockInput[]
): StopExecutionState {
  const lock = stop.lockState;
  if (lock === 'COMPLETED' || lock === 'CURRENT' || lock === 'FUTURE') {
    return lock;
  }
  return 'FUTURE';
}

export function isStopTopologyLocked(state: StopExecutionState): boolean {
  return state === 'COMPLETED' || state === 'CURRENT';
}

export function stopExecutionStateLabel(state: StopExecutionState): string | null {
  if (state === 'COMPLETED') return 'Точка выполнена';
  if (state === 'CURRENT') return 'В исполнении';
  return null;
}

export function canDeleteStopByExecutionState(state: StopExecutionState): boolean {
  return state === 'FUTURE';
}

export function canReorderStopByExecutionState(state: StopExecutionState): boolean {
  return state === 'FUTURE';
}
